import { getDateForFilter } from 'components/ApiTable/helpers/getDateForFilter';
import type { RuleContext } from 'components/Table/components/AdvancedFilter/useRuleContext';

export const dateTimeToNumber = (
  value: string,
  ruleContext: RuleContext,
): number | null => {
  const parsedDate = getDateForFilter(value, ruleContext);
  if (parsedDate && parsedDate.getTime() > 0) {
    return parsedDate.getTime();
  }
  return null;
};
